function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';

var Archive = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(Archive, _Backbone$Model);

  function Archive() {
    return _Backbone$Model.apply(this, arguments) || this;
  }

  var _proto = Archive.prototype;

  _proto.localeName = function localeName(timeZone) {
    if (this.get('created_at')) {
      var created = new Date(this.get('created_at'));

      try {
        var newDateString = created.toLocaleDateString('en-US', {
          timeZone: timeZone
        });
        var newTimeString = created.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          timeZone: timeZone
        });
        return newDateString + " " + newTimeString;
      } catch (error) {
        return created.toDateString() + " " + created.toTimeString({
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    } else {
      return this.get('name');
    }
  };

  return Archive;
}(Backbone.Model);

export { Archive as default };